module.exports = __webpack_public_path__ + "static/media/ionicons.95f6dc8d.ttf";